/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Seg_OtherInputs */

const en_st_seg_other = /** @type {(inputs: St_Seg_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something else`)
};

const id_st_seg_other = /** @type {(inputs: St_Seg_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lainnya`)
};

/**
* | output |
* | --- |
* | "Something else" |
*
* @param {St_Seg_OtherInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_seg_other = /** @type {((inputs?: St_Seg_OtherInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Seg_OtherInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_seg_other(inputs)
	return en_st_seg_other(inputs)
});